export default __webpack_public_path__ + "static/media/deliveries_3.371a27a5.png";